
    export default {
        name: "HappyKidsInsurerTextSection",
        props: {
            anchorLink: {
                type: String,
                default: '#'
            },
            data: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                windowWidth: 0,
                isActive: false,
            }
        },
        computed: {

            btnIconBackground() {
                const style = {
                    'background-image': `url(${require('@/assets/images/common/circle-red-arrow.svg')})`,
                }
                return style
            },

        },
        mounted() {
            this.updateScreenWidth();
            this.onScreenResize();
        },
        methods: {
            /**
             * @return {string[]}
             * @description set section style based on data from CMS.
             */
            sectionStyle() {
                const style = []
                if (this.data?.LayoutStyle?.DisableMinHeight) {
                    style.push({'min-height': 'auto'})
                }
                if (this.data?.LayoutStyle?.PaddingTopInPx >= 0 ) {
                    style.push({'padding-top': `${this.data?.LayoutStyle?.PaddingTopInPx}px`})
                }
                if (this.data?.LayoutStyle?.PaddingBottomInPx >= 0 ) {
                    style.push({'padding-bottom': `${this.data?.LayoutStyle?.PaddingBottomInPx}px`})
                }
                return style
            },
            toggleDescription() {
                this.isActive = !this.isActive;
            },
            onScreenResize() {
                window.addEventListener("resize", () => {
                    this.updateScreenWidth();
                });
            },
            updateScreenWidth() {
                this.windowWidth = window.innerWidth;
            },
            iconSrc(icon) {
                return require(`@/assets/images/family/icon/${icon}.png`)
            }
        },
    }
